module.exports = "/images/26ed883b9ed6aa443a897408cdfb05c3.svg";